/*
  Brand info pages (owner, 2026-10-16): lays out the page text of the policies, Measure My Face Policy, Checkout+,
  Contact information and About in the brand reading layout (numbered sections, "On this page", plates and rows).
  The words stay the ones saved in Shopify; only English pages are rearranged (the labels are English). If a page's
  text does not have the expected shape, it is left as it is.
*/
(function () {
  const root = document.querySelector('[data-sa-doc]');
  if (!root) return;
  // A policy Shopify gives no title for in Liquid takes the title Shopify printed above its text.
  const stageTitle = document.querySelector('[data-sa-doc-stage] .sa-stage__title');
  const shopifyTitle = root.querySelector('.shopify-policy__title h1');
  if (stageTitle && shopifyTitle && !stageTitle.textContent.trim()) stageTitle.textContent = shopifyTitle.textContent.trim();
  if (root.dataset.saEn !== 'true') return;
  const key = root.dataset.saDoc;
  const rte = root.querySelector('.shopify-policy__body .rte') || root.querySelector(':scope > .rte');
  if (!rte) return;
  const stage = document.querySelector('[data-sa-doc-stage]');
  const facts = stage && stage.querySelector('[data-sa-doc-facts]');

  const plain = (html) => html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
  const two = (n) => String(n).padStart(2, '0');
  const escapeHtml = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 8.5 6 12l8-8"/></svg>';
  const DASH = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10"/></svg>';

  // The saved text carries editor leftovers (colour spans, <meta>, data-* attributes); only the structure is kept.
  function clean(html) {
    return html
      .replace(/<meta[^>]*>/g, '')
      .replace(/<\/?span[^>]*>/g, '')
      .replace(/<(p|strong|b|em|i|br|h[1-6]|ul|ol|li)(\s[^>]*?)?(\/?)>/g, '<$1$3>')
      .replace(/<b>/g, '<strong>')
      .replace(/<\/b>/g, '</strong>')
      .replace(/<a\s[^>]*?href="([^"]*)"[^>]*>/g, '<a href="$1">')
      .replace(/\s+/g, ' ');
  }
  // Paragraphs of a block of text: <p> and blank lines (<br><br>) both end a paragraph.
  function paras(html) {
    return html
      .replace(/<\/?p[^>]*>/g, '\n\n')
      .replace(/(\s*<br\s*\/?>\s*){2,}/g, '\n\n')
      .split('\n\n')
      .map((p) => p.replace(/^(\s|<br\s*\/?>)+|(\s|<br\s*\/?>)+$/g, ''))
      .filter((p) => plain(p) !== '');
  }
  const wrapParas = (list) => list.map((p) => `<p>${p}</p>`).join('');

  function addPlate(text, solid) {
    if (!facts) return;
    const plate = document.createElement('span');
    plate.className = 'sa-stage__plate' + (solid ? ' sa-stage__plate--solid' : '');
    plate.textContent = text;
    facts.prepend(plate);
  }
  function addSub(html) {
    if (!stage || stage.querySelector('.sa-stage__sub')) return;
    const sub = document.createElement('p');
    sub.className = 'sa-stage__sub';
    sub.innerHTML = html;
    stage.querySelector('.sa-stage__title').after(sub);
  }
  // "Last updated: …" moves from the text to a plate on the stage.
  function takeUpdated(html) {
    const m = html.match(/<p[^>]*>\s*(?:<strong>)?\s*(Last updated:[^<]*?)\s*(?:<\/strong>)?\s*<\/p>/);
    if (!m) return html;
    addPlate(m[1].trim(), true);
    return html.replace(m[0], '');
  }
  const lead = (html) => html.replace(/<p(?=[\s>])/, '<p class="sa-doc__lead"');

  function section(s) {
    const plate = s.num ? `<span class="sa-plate">${s.num}</span>` : '';
    return `<section class="sa-doc__sec" id="${s.id}"><h2 class="sa-doc__h${s.caps ? ' sa-doc__h--caps' : ''}">${plate}<span>${s.title}</span></h2>${s.body}</section>`;
  }
  function render({ intro = '', sections, toc = true, after = '' }) {
    let aside = '';
    if (toc) {
      const items = sections
        .map((s) => `<li><a href="#${s.id}"><b>${s.num || ''}</b><span>${escapeHtml(plain(s.title))}</span></a></li>`)
        .join('');
      aside = `<aside><details class="sa-toc"><summary><span class="sa-plate">On this page</span></summary><ol>${items}</ol></details></aside>`;
    }
    const grid = document.createElement('div');
    grid.className = 'sa-doc__grid' + (toc ? ' sa-doc__grid--toc' : ' sa-doc__grid--solo');
    grid.innerHTML = `${aside}<div class="rte sa-doc__txt">${intro}${sections.map(section).join('')}${after}</div>`;
    return grid;
  }

  const build = {
    privacy(html) {
      const parts = takeUpdated(html).split(/<h2[^>]*>([\s\S]*?)<\/h2>/);
      if (parts.length < 7) return null;
      const sections = [];
      for (let k = 1; k < parts.length; k += 2) sections.push({ id: `pp-${(k + 1) / 2}`, num: two((k + 1) / 2), title: parts[k].trim(), body: parts[k + 1] });
      return render({ intro: lead(parts[0]), sections });
    },
    mmf(html) {
      const parts = takeUpdated(html).split(/<h2[^>]*>([\s\S]*?)<\/h2>/);
      if (parts.length < 7) return null;
      const sections = [];
      for (let k = 1; k < parts.length; k += 2) {
        const title = parts[k].trim();
        const m = title.match(/^(\d+)\.\s*([\s\S]*)$/);
        if (m) sections.push({ id: `mmf-${m[1]}`, num: two(m[1]), title: m[2], body: parts[k + 1] });
        else sections.push({ id: `mmf-key-${k}`, num: 'Key', title, body: `<div class="sa-doc__ess">${parts[k + 1]}</div>` });
      }
      return render({ intro: lead(parts[0]), sections });
    },
    terms(html) {
      const pieces = html.split(/<strong>\s*(OVERVIEW|SECTION \d+\s*-\s*[^<]+?|SMS\/MMS[^<]+?)\s*<\/strong>/);
      if (pieces.length < 20) return null;
      const sections = [];
      for (let k = 1; k < pieces.length; k += 2) {
        const title = pieces[k].trim();
        const body = wrapParas(paras(pieces[k + 1]));
        const m = title.match(/^SECTION (\d+)\s*-\s*(.*)$/);
        if (m) sections.push({ id: `tos-${m[1]}`, num: two(m[1]), title: m[2], body, caps: true });
        else if (title === 'OVERVIEW') sections.push({ id: 'tos-0', num: '00', title, body, caps: true });
        else sections.push({ id: 'tos-sms', num: 'SMS', title, body, caps: true });
      }
      return render({ intro: wrapParas(paras(pieces[0])), sections });
    },
    refund(html) {
      const list = paras(html);
      const groups = [{ title: 'Returns', body: [] }];
      for (const p of list) {
        const m = p.match(/^<strong>([^<]+)<\/strong>\s*<br\s*\/?>\s*([\s\S]*)$/);
        if (m) groups.push({ title: m[1].trim(), body: m[2].trim() ? [m[2]] : [] });
        else groups[groups.length - 1].body.push(p);
      }
      if (groups.length < 4 || !groups[0].body.length) return null;
      const account = (html.match(/href="([^"]*account[^"]*)"/) || [])[1] || '/account';
      const sections = groups.map((g, k) => ({
        id: `rf-${k + 1}`,
        num: two(k + 1),
        title: g.title,
        body: wrapParas(g.body) + (k === 0 ? `<div class="sa-doc__btns"><a class="sa-doc__btn" href="${account}">Start a return →</a></div>` : ''),
      }));
      const glance =
        '<div class="sa-doc__glance"><div><b>30</b><span>days to request a free return or exchange</span></div>' +
        '<div><b>Free</b><span>return label for approved returns</span></div>' +
        '<div><b>10</b><span>business days to refund once approved</span></div></div>';
      return render({ intro: glance, sections });
    },
    shipping(html) {
      html = takeUpdated(html.replace(/<h1[^>]*>[\s\S]*?<\/h1>/, ''));
      const parts = html.split(/<p[^>]*>\s*<strong>([^<]+)<\/strong>\s*<\/p>/);
      if (parts.length < 7) return null;
      const sections = [];
      for (let k = 1; k < parts.length; k += 2) {
        const body = parts[k + 1].replace(/<p>(\s*<strong>)/g, '<p class="sa-doc__region">$1');
        sections.push({ id: `sh-${(k + 1) / 2}`, num: two((k + 1) / 2), title: parts[k].trim(), body });
      }
      return render({ intro: parts[0], sections });
    },
    checkout(html) {
      const parts = html.split(/<p[^>]*>\s*<strong>([^<]+)<\/strong>\s*<\/p>/);
      if (parts.length < 7) return null;
      const blocks = [];
      for (let k = 1; k < parts.length; k += 2) blocks.push({ title: parts[k].trim(), list: paras(parts[k + 1]) });
      const no = blocks.find((b) => /not cover/i.test(b.title));
      const sections = [];
      for (const b of blocks) {
        if (b === no) continue;
        let body = wrapParas(b.list);
        if (/covers/i.test(b.title) && no && b.list.length > 1 && no.list.length > 1) {
          const col = (label, items, icon, cls) =>
            `<div class="${cls}"><h3><span class="sa-plate">${label}</span></h3><p>${items[0]}</p><ul>${items.slice(1).map((x) => `<li>${icon}<span>${x}</span></li>`).join('')}</ul></div>`;
          body = `<div class="sa-doc__cover">${col('Covers', b.list, CHECK, '')}${col('Not covered', no.list, DASH, 'sa-doc__cover-no')}</div>`;
        }
        sections.push({ id: `cp-${sections.length + 1}`, num: two(sections.length + 1), title: b.title, body });
      }
      return render({ intro: lead(wrapParas(paras(parts[0]))), sections });
    },
    contact(html) {
      const get = (re) => (html.match(re) || [])[1];
      const usa = get(/<strong>USA Phone<\/strong>\s*:?\s*([^<]+)/);
      const tr = get(/<strong>TR Phone<\/strong>\s*:?\s*([^<]+)/);
      const email = plain(get(/<strong>Email<\/strong>\s*:?\s*((?:<a[^>]*>)?[^<]*(?:<\/a>)?)/) || '');
      if (!usa || !tr || !email.includes('@')) return null;
      const note = get(/<em>([\s\S]*?)<\/em>/);
      const addr = (label) => (get(new RegExp(`<strong>${label}<\\/strong>\\s*:?\\s*(?:<br\\s*\\/?>)?([\\s\\S]*?)<\\/p>`)) || '').trim();
      const list = paras(html);
      const operated = list.find((p) => /operated by/i.test(p));
      const help = list.find((p) => /^Need help/i.test(plain(p)));
      const chat = list.find((p) => /Prefer chatting/i.test(p));
      const insta = chat && (chat.match(/href="([^"]*instagram[^"]*)"/) || [])[1];
      if (help) addSub(help);
      const row = (label, value, extra = '') => `<div class="sa-doc__row"><span>${label}</span><div><b>${value}</b>${extra}</div></div>`;
      const tel = (n) => `<a href="tel:${n.replace(/[^\d+]/g, '')}">${n.trim()}</a>`;
      let body = operated ? `<p class="sa-doc__lead">${operated}</p>` : '';
      body += '<div class="sa-doc__card">' + row('USA Phone', tel(usa)) + row('TR Phone', tel(tr)) +
        row('Email', `<a href="mailto:${email}">${email}</a>`, note ? `<p class="sa-doc__note"><em>${note}</em></p>` : '') + '</div>';
      const usaAddr = addr('USA Address');
      const trAddr = addr('TR Address');
      if (usaAddr || trAddr) {
        body += '<div class="sa-doc__addr">' + (usaAddr ? `<div class="sa-doc__card">${row('USA Address', usaAddr)}</div>` : '') +
          (trAddr ? `<div class="sa-doc__card">${row('TR Address', trAddr)}</div>` : '') + '</div>';
      }
      if (chat) {
        body += `<p style="margin-top:2.8rem">${plain(chat).replace(/[\[\]]/g, '')}</p><div class="sa-doc__btns"><a class="sa-doc__btn" href="#chat">Chat with us</a>` +
          (insta ? `<a class="sa-doc__btn sa-doc__btn--ghost" href="${insta}">Instagram DM</a>` : '') + '</div>';
      }
      return render({ intro: body, sections: [], toc: false });
    },
    about(html) {
      const ICONS = [
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 3 27 7v8c0 7-5 12-11 14C10 27 5 22 5 15V7Z"/></svg>',
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M8 20c0-7 6-13 18-14-1 12-7 18-14 18-2 0-4-1-4-4Z"/><path d="M6 27l9-9"/></svg>',
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M6 26 22 10l4 4L10 30H6Z"/><path d="m19 13 4 4"/><path d="M22 4l2 4 4 2-4 2-2 4-2-4-4-2 4-2Z"/></svg>',
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M10 9a10 10 0 1 1-3 11"/><path d="M4 7l3 6 6-3"/></svg>',
      ];
      const list = paras(html);
      let intro = '';
      let after = '';
      const sections = [];
      let why = [];
      list.forEach((p, k) => {
        const strongOnly = p.match(/^<strong>([^<]+)<\/strong>$/);
        const strongBr = p.match(/^<strong>([^<]+)<\/strong>\s*<br\s*\/?>\s*([\s\S]+)$/);
        if (k === 0 && strongOnly) return addSub(strongOnly[1]);
        if (/^\s*✔/.test(p)) {
          why.push(plain(p).replace(/^✔️?\s*/, ''));
          return;
        }
        if (why.length && sections.length) {
          sections[sections.length - 1].body += `<div class="sa-doc__why">${why.map((w, i) => `<div>${ICONS[i % ICONS.length]}<span>${w}</span></div>`).join('')}</div>`;
          why = [];
        }
        if (strongOnly) sections.push({ id: `ab-${sections.length + 1}`, title: strongOnly[1], body: '' });
        else if (strongBr) sections.push({ id: `ab-${sections.length + 1}`, title: strongBr[1], body: `<p>${strongBr[2]}</p>` });
        else if (/^\s*👉/.test(p)) {
          const link = p.match(/<a[^>]*href="([^"]+)"[^>]*>([\s\S]*?)<\/a>\s*[–—-]?\s*([\s\S]*)$/);
          after = link
            ? `<div class="sa-doc__btns" style="margin-top:2.8rem"><a class="sa-doc__btn" href="${link[1]}">${plain(link[2])} →</a></div><p>${plain(link[3])}</p>`
            : `<p>${p}</p>`;
        } else if (!sections.length) intro += `<p${intro ? '' : ' class="sa-doc__lead"'}>${p}</p>`;
        else sections[sections.length - 1].body += `<p>${p}</p>`;
      });
      if (sections.length < 2) return null;
      for (const s of sections) {
        const m = s.body.match(/^<p>([\s\S]*?(\d+\+)\s*countries[\s\S]*?)<\/p>$/);
        if (m) s.body = `<div class="sa-doc__stat"><b>${m[2]}</b><p>${m[1]}</p></div>`;
      }
      return render({ intro, sections, toc: false, after });
    },
  };

  let grid = null;
  try {
    grid = build[key] ? build[key](clean(rte.innerHTML)) : null;
  } catch (error) {
    grid = null;
  }
  if (!grid) return;
  rte.replaceWith(grid);
  root.classList.add('sa-doc--ready');

  // About videos (snippets/sa-about-media.liquid): workshop under the intro, event slider after the first section.
  if (key === 'about') {
    const take = (id) => { const t = document.getElementById(id); return t ? t.content.firstElementChild.cloneNode(true) : null; };
    const workshop = take('SaAboutWorkshop');
    const events = take('SaAboutEvents');
    const firstSec = grid.querySelector('.sa-doc__sec');
    if (workshop && firstSec) firstSec.before(workshop);
    if (events && firstSec) firstSec.after(events);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const videos = [...grid.querySelectorAll('[data-sa-about-video]')];
    const track = grid.querySelector('[data-sa-about-track]');
    const inTrackView = (v) => {
      if (!track || !track.contains(v)) return true;
      const slide = v.closest('.sa-about-ev__slide');
      return Math.abs(slide.offsetLeft - track.scrollLeft) < track.clientWidth / 2;
    };
    const seen = new Set();
    const sync = () => videos.forEach((v) => {
      if (!reduce && seen.has(v) && inTrackView(v)) v.play().catch(() => {});
      else v.pause();
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
        sync();
      }, { threshold: 0.35 });
      videos.forEach((v) => io.observe(v));
    }
    if (track) {
      const dots = [...grid.querySelectorAll('[data-sa-about-dot]')];
      const current = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach((dot) => dot.addEventListener('click', () => {
        track.scrollTo({ left: track.clientWidth * Number(dot.dataset.saAboutDot), behavior: reduce ? 'auto' : 'smooth' });
      }));
      let raf = 0;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = current();
          dots.forEach((d, n) => d.setAttribute('aria-pressed', String(n === i)));
          sync();
        });
      }, { passive: true });
    }
  }

  const toc = grid.querySelector('.sa-toc');
  if (toc) {
    const wide = window.matchMedia('(min-width: 990px)');
    toc.open = wide.matches;
    toc.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', link.getAttribute('href'));
      if (!wide.matches) toc.open = false;
    });
  }
  if (location.hash) document.getElementById(location.hash.slice(1))?.scrollIntoView();
})();
